module.exports = function (f) {
  var html = "\n    <div class=\"welcome welcome-".concat(f, "\">\n      <div class=\"welcome-title\"></div>\n      <div class=\"welcome-text\"></div>\n    </div>\n  ");
  return html;
};